import { render, staticRenderFns } from "./verificacion.vue?vue&type=template&id=1b088af6&"
import script from "./verificacion.vue?vue&type=script&lang=js&"
export * from "./verificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports